import isNil from 'lodash/isNil';
import createAction from './';
import { getLoginOrganizationDetails } from './getLoginOrganizationDetails';
import { getOrganizationById } from './getOrganizationById';
import { fetchOrganizationLogo } from './fetchOrganizationLogo';
import { changeOrganizationLogo } from './changeOrganizationLogo';


export const SELECT_ORGANIZATION_TOKEN = createAction('SELECT_ORGANIZATION_TOKEN');
export const RESET_ORGANIZATION_TOKEN = createAction('RESET_ORGANIZATION_TOKEN');
export const UPDATE_ORGANIZATION_SELECTION_ERROR = createAction('UPDATE_ORGANIZATION_SELECTION_ERROR');
export const RESET_ORGANIZATION_SELECTION_ERROR = createAction('RESET_ORGANIZATION_SELECTION_ERROR');
export const SUBMIT_ORGANIZATION_SELECTION = createAction('SUBMIT_ORGANIZATION_SELECTION');

const resetOrganizationSelectionErrorWithValidation = () => (dispatch, getState) => {
  const selectedOrganizationHasError = getState().auth.organizations.hasError;

  if (selectedOrganizationHasError) {
    dispatch({ type: RESET_ORGANIZATION_SELECTION_ERROR });
  }
};

export const selectOrganizationToken = (selectedOrganizationToken) => (dispatch) => {
  if (isNil(selectedOrganizationToken)) {
    return dispatch({ type: RESET_ORGANIZATION_TOKEN });
  }

  dispatch(resetOrganizationSelectionErrorWithValidation());

  dispatch(fetchOrganizationLogo(selectedOrganizationToken))
    .then(() => dispatch(changeOrganizationLogo()));

  dispatch(getOrganizationById(selectedOrganizationToken));

  return dispatch({
    type: SELECT_ORGANIZATION_TOKEN,
    payload: { selectedOrganizationToken },
  });
};

export const handleOrganizationSelectionFocus = () => (dispatch) => {
  return dispatch(resetOrganizationSelectionErrorWithValidation());
};

export const submitOrganizationSelectionForm = () => (dispatch, getState) => {
  const { selectedOrganizationToken } = getState().auth.organizations;
  const hasError = !selectedOrganizationToken;

  if (hasError) {
    return dispatch({
      type: UPDATE_ORGANIZATION_SELECTION_ERROR,
      meta: { hasError },
    });
  }

  return dispatch(getLoginOrganizationDetails())
    .then(() => dispatch({ type: SUBMIT_ORGANIZATION_SELECTION }));
};
